<!-- prettier-ignore  -->
<template>
  <div class="BcLayout__Footer px-5 py-1 mt-10 hidden lg:flex items-center text-gray-400 text-xs border-t border-gray-200">
    <div class="flex flex-wrap gap-x-3 items-center lg:justify-start">
      <span class="w-full">{{ slots.slot1.name }}</span>
      <div class="w-full text-left gap-x-3 gap-y-1">
        <span v-if="slots.slot1.phone" class="BcLayout__FooterPhone"><aw-icon icon="phone" class="h-4 w-5 " /> {{ slots.slot1.phone  }}</span>
        <span v-if="slots.slot1.email" class="BcLayout__FooterEmail"><aw-icon icon="email" class="h-4 w-5 " /> <a :href="'mailto:' + slots.slot1.email">{{ slots.slot1.email  }}</a></span>
      </div>
    </div>
    <div class="flex flex-wrap items-center gap-x-3 gap-y-1 justify-start lg:justify-center">
     <span class="w-full">{{ slots.slot2.name }}</span>
      <div class="w-full space-x-3">
        <span v-if="slots.slot2.phone" class="BcLayout__FooterPhone"><aw-icon icon="phone" class="h-4 w-5 " /> {{ slots.slot2.phone  }}</span>
        <span v-if="slots.slot2.email" class="BcLayout__FooterEmail"><aw-icon icon="email" class="h-4 w-5 " />  <a :href="'mailto:' + slots.slot2.email">{{ slots.slot2.email  }}</a></span>
      </div>
    </div>
    <div v-if="slots.slot3" class="flex flex-wrap items-center gap-x-3 gap-y-1 justify-start lg:justify-center">
      <span class="w-full">{{ slots.slot3.name }}</span>
      <div class="w-full space-x-3">
        <span v-if="slots.slot3.phone" class="BcLayout__FooterPhone"><aw-icon icon="phone" class="h-4 w-5 " /> {{ slots.slot3.phone  }}</span>
        <span v-if="slots.slot3.email" class="BcLayout__FooterEmail"><aw-icon icon="email" class="h-4 w-5 " />  <a :href="'mailto:' + slots.slot3.email">{{ slots.slot3.email  }}</a></span>
      </div>
    </div>
    <!--
    <div 
      v-if="unsplashCredits && unsplashCredits.length" 
      class="flex flex-wrap items-center gap-x-3 gap-y-1 justify-start lg:justify-center w-1/4"
    >
      <span class="w-full">
        {{ $t('Photo by') }}
      </span>
      <div class="w-full space-x-3">
        <span>
          <template 
            v-for="(credit, i) in displayedUnsplashCredits"
            :key="i"
          >
            <a 
              :href="credit.unsplash_url"
            >
              {{ credit.author  }}
            </a>
            on 
            <a href="https://unsplash.com/?utm_source=brandcloud&utm_medium=referral">Unsplash</a><template v-if="i < displayedUnsplashCredits.length - 1">, </template>
          </template>
        </span>
        <button
          v-if="unsplashCredits.length > 3"
          @click="showAllUnsplashCredits = !showAllUnsplashCredits"
        >
          {{ showAllUnsplashCredits ? $t('Show less') : $t('Show more') }}
        </button>
      </div>
    </div>
    -->
    <div class="flex items-center space-x-4 justify-start lg:justify-end ml-auto">
      <a href="https://brandcloud.pro" target="_blank">
        <img 
          src="/assets/gfx/logo-footer.svg" 
          class="h-10" 
          alt="" 
          draggable="false"
        />
      </a>
    </div>
  </div>


</template>

<script>
export default {
  props: {
    data: {
      type: Object,
    },
    unsplashCredits: {
      type: Array,
      default: () => {
        return [
          {
            author: 'Annie Spratt',
            unsplash_url: 'https://unsplash.com/@anniespratt?utm_source=your_app_name&utm_medium=referral'
          },
          {
            author: 'Annie Spratt',
            unsplash_url: 'https://unsplash.com/@anniespratt?utm_source=your_app_name&utm_medium=referral'
          },
          {
            author: 'Annie Spratt',
            unsplash_url: 'https://unsplash.com/@anniespratt?utm_source=your_app_name&utm_medium=referral'
          },
          {
            author: 'Annie Spratt',
            unsplash_url: 'https://unsplash.com/@anniespratt?utm_source=your_app_name&utm_medium=referral'
          },
          {
            author: 'Annie Spratt',
            unsplash_url: 'https://unsplash.com/@anniespratt?utm_source=your_app_name&utm_medium=referral'
          },
        ]
      }
    }
  },
  data() {
    return {
      showAllUnsplashCredits: false,
      defaultSlots: {
        slot1: {
          name: this.$t('Content manager'),
          phone: this.$t('+420 777 211 344'),
          email: this.$t('info@brandcloud.pro'),
        },
        slot2: {
          name: this.$t('Technical support'),
          phone: this.$t('+420 777 211 344'),
          email: this.$t('info@brandcloud.pro'),
        },
        slot3: null
      },
      filledSlots: {
        slot1: {
          name: this.data.rp_name,
          phone: this.data.rp_phone,
          email: this.data.rp_email,
        },
        slot2: {
          name: this.data.ts_name,
          phone: this.data.ts_phone,
          email: this.data.ts_email,
        },
        slot3: {
          name: this.data.cc_name,
          phone: this.data.cc_phone,
          email: this.data.cc_email,
        }
      }
    }
  },
  computed: {
    slots() {
      return {
        slot1: this.filledSlots.slot1.name
          ? this.filledSlots.slot1
          : this.defaultSlots.slot1,
        slot2: this.filledSlots.slot2.name
          ? this.filledSlots.slot2
          : this.defaultSlots.slot2,
        slot3: this.filledSlots.slot3.name
          ? this.filledSlots.slot3
          : this.defaultSlots.slot3
      }
    },
    displayedUnsplashCredits() {
      if (!this.showAllUnsplashCredits && this.unsplashCredits.length > 3) {
        return this.unsplashCredits.slice(0, 3)
      } else {
        return this.unsplashCredits
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.BcLayout__Footer > * {
  //outline: 1px solid limegreen;
}

.BcLayout__FooterPhone {
  margin-left: -0.125rem;
}

.BcLayout__FooterEmail {
  margin-left: 0.5rem !important;
}
</style>
